import styles from './activityContainer.module.scss';

export type ActivityContainerProps = {
  readonly children: React.ReactNode;
  readonly backgroundType?:
    | 'landing'
    | 'blank'
    | 'space'
    | 'whatIsAsthma'
    | 'whatIsAsthmaGame'
    | 'whatIsAsthmaQuiz'
    | 'spaceGame'
    | 'asthmaTrigger'
    | 'asthmaTriggerQuiz'
    | 'asthmaEmergency'
    | 'asthmaEmergencyQuiz'
    | 'asthmaEmergencyGame1'
    | 'asthmaEmergencyGame2'
    | 'asthmaEmergencyGame2b'
    | 'asthmaEmergencyGame2c'
    | 'asthmaEmergencyGame3'
    | 'asthmaEmergencyGame3b'
    | 'asthmaEmergencyGame4'
    | 'asthmaEmergencyGame5'
    | 'everydayPlanetGame'
    | 'everydayPlanetGameQuiz1'
    | 'everydayPlanetGameQuiz2'
    | 'everydayPlanetGameQuizSuccess'
    | 'friendshipSatellite'
    | 'friendshipSatelliteQuiz';
};

export default function ActivityContainer({
  children = null,
  backgroundType = 'space'
}: ActivityContainerProps) {
  const backgroundClassName = styles[`${backgroundType}Background`];

  return (
    <div className={styles.activityContainer}>
      <div
        className={`${styles.activityBackground} ${backgroundClassName ?? ''}`}
      >
        <div className={styles.innerContainer}>{children}</div>
      </div>
    </div>
  );
}
